import { FC } from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import { usePageTitle } from 'hooks/usePageTitle';
import { useRemoveRubyTags } from 'hooks/useRemoveRubyTags';

import { Button } from 'components/parts/Button';
import BgTitle from 'images/area/answer/bg_mission-title.svg';

import styles from './MissionResult.module.scss';
import { useMissionRelatedData } from 'hooks/useMissionRelatedData';
export const MissionResult: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { article } = useMissionRelatedData(Number(id));
  const nextUrl = '/home';
  usePageTitle(useRemoveRubyTags(article?.name));

  function getClearCardFileName() {
    return `10${id}_mission-clear-card.webp`;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.head}>
          <h1 className={styles.title}>
            <img src={BgTitle} alt="クリアカードGET" className={styles.titleImage} />
          </h1>
        </div>
        <div className={styles.body}>
          <div className={styles.imageWrap}>
            <img
              src={require(`images/character/chara-kirakira.webp`)}
              alt=""
              className={styles.chara}
            />
            <img
              src={require(`components/pages/Area/images/${getClearCardFileName()}`)}
              alt=""
              className={styles.image}
            />
            <div className={styles.sparcles}>
              <svg
                className={styles.sparcle1}
                id="sparcle1"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
                  fill="url(#paint0_radial_633_6738)"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_633_6738"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 16) rotate(90) scale(12 10)"
                  >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFE588" />
                  </radialGradient>
                </defs>
              </svg>
              <svg
                className={styles.sparcle2}
                id="sparcle2"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
                  fill="url(#paint0_radial_633_6738)"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_633_6738"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 16) rotate(90) scale(12 10)"
                  >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFE588" />
                  </radialGradient>
                </defs>
              </svg>
              <svg
                className={styles.sparcle4}
                id="sparcle4"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
                  fill="url(#paint0_radial_633_6738)"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_633_6738"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 16) rotate(90) scale(12 10)"
                  >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFE588" />
                  </radialGradient>
                </defs>
              </svg>
              <svg
                className={styles.sparcle3}
                id="sparcle3"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
                  fill="url(#paint0_radial_633_6738)"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_633_6738"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 16) rotate(90) scale(12 10)"
                  >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFE588" />
                  </radialGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
        <div className={styles.action}>
          <div className={styles.actionBody}>
            <div className={styles.actionBodyText}>
              この画面をスタッフに見せて
              <br />
              実物のカードをもらおう！
            </div>

            <Button text="ホームに戻る" styleType="primary" handleClick={() => navigate(nextUrl)} />
          </div>
        </div>
      </div>
    </div>
  );
};
